import React from 'react';
import { Truck, Package, MapPin, Clock } from 'lucide-react';

const shipments = [
  {
    id: 'SHP-001',
    order: 'ORD-001',
    customer: 'John Doe',
    status: 'In Transit',
    carrier: 'DHL Express',
    trackingNo: 'DHL123456789',
    estimatedDelivery: '2025-04-18',
  },
  {
    id: 'SHP-002',
    order: 'ORD-002',
    customer: 'Jane Smith',
    status: 'Delivered',
    carrier: 'FedEx',
    trackingNo: 'FDX987654321',
    estimatedDelivery: '2025-04-15',
  },
  {
    id: 'SHP-003',
    order: 'ORD-003',
    customer: 'Mike Johnson',
    status: 'Processing',
    carrier: 'UPS',
    trackingNo: 'UPS456789123',
    estimatedDelivery: '2025-04-20',
  },
];

export default function Shipping() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Shipping Management</h2>

      {/* Shipping Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-purple-100 p-3 rounded-lg">
              <Package className="h-6 w-6 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Pending Shipments</p>
              <p className="text-2xl font-bold">24</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <Truck className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">In Transit</p>
              <p className="text-2xl font-bold">18</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-green-100 p-3 rounded-lg">
              <MapPin className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Delivered Today</p>
              <p className="text-2xl font-bold">12</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-orange-100 p-3 rounded-lg">
              <Clock className="h-6 w-6 text-orange-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Avg. Delivery Time</p>
              <p className="text-2xl font-bold">2.5d</p>
            </div>
          </div>
        </div>
      </div>

      {/* Shipments Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold">Recent Shipments</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50">
                <th className="text-left py-3 px-4">Shipment ID</th>
                <th className="text-left py-3 px-4">Order</th>
                <th className="text-left py-3 px-4">Customer</th>
                <th className="text-left py-3 px-4">Status</th>
                <th className="text-left py-3 px-4">Carrier</th>
                <th className="text-left py-3 px-4">Tracking No.</th>
                <th className="text-left py-3 px-4">Est. Delivery</th>
              </tr>
            </thead>
            <tbody>
              {shipments.map((shipment) => (
                <tr key={shipment.id} className="border-t border-gray-200">
                  <td className="py-3 px-4 font-medium">{shipment.id}</td>
                  <td className="py-3 px-4">{shipment.order}</td>
                  <td className="py-3 px-4">{shipment.customer}</td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 rounded-full text-sm ${
                      shipment.status === 'In Transit'
                        ? 'bg-blue-100 text-blue-700'
                        : shipment.status === 'Delivered'
                        ? 'bg-green-100 text-green-700'
                        : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {shipment.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">{shipment.carrier}</td>
                  <td className="py-3 px-4">
                    <a href="#" className="text-purple-600 hover:text-purple-700">
                      {shipment.trackingNo}
                    </a>
                  </td>
                  <td className="py-3 px-4">{shipment.estimatedDelivery}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}